import type { AdminCenterDataRequest } from '@routes/sidebar/___shared___/api/adminCenterData.api.ts';
import { ADMIN_CENTER_DATA } from '@routes/sidebar/___shared___/api/constants.ts';

export const MATRIX_PATHWAY_TYPE = {
    ByRankOnly: 'ByRankOnly',
    ByVesselGroup: 'ByVesselGroup',
} as const;

export const MATRIX_PATHWAY_TRIGGER = {
    SinceRequirementStart: 'SinceRequirementStart',
    SinceVesselAssignment: 'SinceVesselAssignment',
    AfterSignOn: 'AfterSignOn',
} as const;

export const MATRIX_PATHWAY_CATEGORY = {
    Mandatory: 'Mandatory',
    Recommended: 'Recommended',
} as const;

export const MATRIX_PATHWAY_STATUS = {
    Default: 'Default',
    Draft: 'Draft',
    Published: 'Published',
} as const;

export const MATRIX_PATHWAY_TIME_UNIT = {
    Hour: 'Hour',
    Week: 'Week',
    Month: 'Month',
    Year: 'Year',
} as const;

export const DASHBOARD_ACCESS_KEYS = {
    LEARNING_REQUIREMENTS: 'learningRequirements',
    ONBOARD_ASSESSORS: 'onboardAssessors',
    DASHBOARD_ACCESS: 'dashboardAccess',
} as const;

export const MATRICES_DATA_PAYLOAD: AdminCenterDataRequest = {
    dataToReturn: [
        ADMIN_CENTER_DATA.VESSEL_GROUPS,
        ADMIN_CENTER_DATA.VESSELS,
        ADMIN_CENTER_DATA.VESSEL_SUB_TYPES,
        ADMIN_CENTER_DATA.SHORE_USERS,
        ADMIN_CENTER_DATA.VESSEL_DEPARTMENTS,
        ADMIN_CENTER_DATA.PROFICIENCY_LEVELS,
        ADMIN_CENTER_DATA.RANK_SETS_WITH_REFERENCE,
    ],
};
